import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import ServiceLogo from 'assets/images/Dashboard/Logo.png';
import ReusableButton from 'components/common/Button';
import MuiBreadcrumbs from 'components/common/MuiBreadcrumbs';
import { superAdminCoupons } from 'routes/AppUrls';
import LabelWithInput from 'components/common/Input/LabelWithInput';
import leftArrow from 'assets/images/Dashboard/arrow-left.png';
import SelectInput from 'components/common/Input/SelectInput';
import { useDispatch, useSelector } from 'react-redux';
import ToastNotification from 'components/common/Toast';
import CheckValidation from 'utils/Validation';
import CircularProgress from '@mui/material/CircularProgress';
import { getAssociationCallAPI } from 'store/SuperAdmin/getAssociationsList/action';
import MultiSelectChip from 'components/common/Input/MultiSelectChip';
import { addCouponCallAPI } from 'store/SuperAdmin/createCoupon/action';
import moment from 'moment';

const CreateCoupon = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const { locale } = useContext(LocaleContext);

  const [isError, setIsError] = useState(null);
  const [productListData, setProductListData] = useState([]);
  const couponLoader = useSelector((state) => state?.addCouponReducer?.loading);

  const [formValue, setFormValue] = useState({
    couponName: '',
    couponCode: '',
    startDateTime: null,
    endDateTime: null,
    discountProduct: '',
    discountType: '',
    discountValue: '',
    conditionType: '',
    conditionValue: '',
    usage: '',
  });

  const [formId, setFormId] = useState({
    discountProduct: '',
    discountType: '',
    conditionType: '',
    usage: '',
  });

  const [breadcrumbsList, setBreadcrumbsList] = useState([
    {
      title: <FormattedMessage id="Coupons" />,
      Link: superAdminCoupons(locale),
      isDisbale: false,
    },
    {
      title: <FormattedMessage id="Create Coupon" />,
      Link: '',
      isDisbale: true,
    },
  ]);

  const usageList = [
    {
      name: 'Single use',
      slug: 'Single use',
    },
    { name: 'Multi use', slug: 'Multi-use' },
    // { name: 'Once per customer', slug: 'Once per customer' },
  ];

  const conditionList = [
    {
      name: 'Count',
      slug: 'Count',
    },
    { name: 'Value', slug: 'Value' },
    //{ name: 'Coverage', slug: 'Coverage' },
  ];

  const discountList = [
    {
      name: 'Percentage',
      slug: 'Percentage',
    },
    { name: 'Fixed', slug: 'Fixed' },
    //{ name: 'Multibuy', slug: 'Multibuy' },
  ];

  useEffect(() => {
    getProductList();
  }, []);

  const getProductList = () => {
    dispatch(
      getAssociationCallAPI(
        {},
        {
          run: true,
          navigate: navigate,
          handleFunction: (res) => handleProductListSuccess(res),
        }
      )
    );
  };

  const handleProductListSuccess = (res) => {
    setProductListData(res?.data?.data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'couponCode') {
      setFormValue((prev) => ({
        ...prev,
        [name]: value.replace(/\s+/g, '').toUpperCase(),
      }));
    } else {
      setFormValue((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValue((prev) => ({
      ...prev,
      [name]: value?.name,
    }));
    setFormId((prev) => ({
      ...prev,
      [name]: value?.slug,
    }));
  };

  const handleMultiSelectChip = (name, data) => {
    setFormValue({ ...formValue, [name]: data });
  };

  const handleCreateCoupon = () => {
    const {
      couponName,
      couponCode,
      startDateTime,
      endDateTime,
      // discountProduct,
      discountType,
      discountValue,
      conditionType,
      conditionValue,
      usage,
    } = formValue;
    const error = CheckValidation({
      couponName,
      couponCode,
      startDateTime,
      endDateTime,
      // discountProduct,
      discountType,
      discountValue,
      conditionType,
      conditionValue,
      usage,
    });
    setIsError(error);
    if (error.submit) {
      let body = {
        name: formValue?.couponName,
        code: formValue?.couponCode,
        benefit_type: formValue?.discountType,
        range_id: 1,
        benefit_value: formValue?.discountValue,
        condition_type: formValue?.conditionType,
        condition_value: formValue?.conditionValue,
        start_datetime: moment(formValue?.startDateTime)?.utc().format(),
        end_datetime: moment(formValue?.endDateTime)?.utc().format(),
      };

      dispatch(
        addCouponCallAPI(body, {
          run: true,
          handleFunction: (res) => handleRedirect(res),
          toast: true,
          handleToastError: (res) => handleRedirectError(res),
          navigate: navigate,
        })
      );
    }
  };

  const handleRedirect = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    navigate(superAdminCoupons(locale));
  };

  const handleRedirectError = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'error',
    });
  };

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <MuiBreadcrumbs size="14" list={breadcrumbsList} />
        <Row className="bc-FFFFFF m-0 p-16 mt-3">
          <div className="flex justify-between items-center">
            <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
              <Stack direction="horizontal" gap={2} className="items-center">
                <img
                  src={leftArrow}
                  alt="icon"
                  style={{ height: '32px', width: '32px' }}
                  className="cursor-pointer"
                  onClick={() => navigate(superAdminCoupons(locale))}
                />
                <p className="p-0 m-0">
                  <FormattedMessage id="Coupon" />
                </p>
              </Stack>
            </h2>
            <img
              src={ServiceLogo}
              alt={'logo'}
              style={{ height: '64px', width: '96px' }}
            />
          </div>

          <Col sm={12} md={6} className="">
            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Name" />}
                required={true}
                placeholder={intl.formatMessage({
                  id: 'Name',
                })}
                name="couponName"
                type="text"
                value={formValue?.couponName}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.couponName?.error &&
                  isError?.couponName?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Code" />}
                required={true}
                placeholder={intl.formatMessage({
                  id: 'Code',
                })}
                name="couponCode"
                type="text"
                value={formValue?.couponCode}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.couponCode?.error &&
                  isError?.couponCode?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Start datetime" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'Start datetime' })}
                name="startDateTime"
                type="datetime-local"
                value={formValue?.startDateTime}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.startDateTime?.error &&
                  isError?.startDateTime?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="End datetime" />}
                required={true}
                placeholder={intl.formatMessage({ id: 'End datetime' })}
                name="endDateTime"
                type="datetime-local"
                value={formValue?.endDateTime}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.endDateTime?.error &&
                  isError?.endDateTime?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Usage" />}
                required={true}
                placeholder={intl.formatMessage({
                  id: 'Usage',
                })}
                name={'usage'}
                value={formValue?.usage}
                data={usageList}
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError &&
                  isError?.usage?.error &&
                  isError?.usage?.errorMessage
                }
              />
            </Col>
          </Col>

          <Col sm={12} md={6} className="">
            {/* <Col xs={12} md={12} className="pt-15 mt-3">
              <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                <FormattedMessage id="Which products get a discount ?" />
              </p>
              <div className="mt-2">
                <MultiSelectChip
                  options={productListData}
                  value={formValue?.discountProduct}
                  onSelect={(selected) =>
                    handleMultiSelectChip('discountProduct', selected)
                  }
                  onRemove={(removed) =>
                    handleMultiSelectChip('discountProduct', removed)
                  }
                  onSearch={(searchTerm) => console.log(searchTerm)}
                  height="50px"
                  // width="400px"
                  dropdownBg="#fff7ed"
                  chipBg="#22c55e" // Tailwind green-500
                  errorText={
                    isError &&
                    isError.discountProduct.error &&
                    isError.discountProduct.errorMessage
                  }
                />
              </div>
            </Col> */}

            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Discount type" />}
                //required={true}
                placeholder={intl.formatMessage({
                  id: 'Discount type',
                })}
                name={'discountType'}
                value={formValue?.discountType}
                data={discountList}
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError &&
                  isError?.discountType?.error &&
                  isError?.discountType?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Discount value" />}
                //required={true}
                placeholder={intl.formatMessage({ id: 'Discount value' })}
                name="discountValue"
                type="number"
                value={formValue?.discountValue}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.discountValue?.error &&
                  isError?.discountValue?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <SelectInput
                label={<FormattedMessage id="Condition type" />}
                //required={true}
                placeholder={intl.formatMessage({
                  id: 'Condition type',
                })}
                name={'conditionType'}
                value={formValue?.conditionType}
                data={conditionList}
                onChange={(e) => handleInputChange(e)}
                errorText={
                  isError &&
                  isError?.conditionType?.error &&
                  isError?.conditionType?.errorMessage
                }
              />
            </Col>

            <Col xs={12} md={12} className="mt-3">
              <LabelWithInput
                label={<FormattedMessage id="Condition value" />}
                //required={true}
                placeholder={intl.formatMessage({ id: 'Condition value' })}
                name="conditionValue"
                type="number"
                value={formValue?.conditionValue}
                onChange={(e) => handleChange(e)}
                errorText={
                  isError &&
                  isError?.conditionValue?.error &&
                  isError?.conditionValue?.errorMessage
                }
              />
            </Col>
          </Col>

          <Row className="mt-5 mb-3 items-end m-0 p-0">
            <div className="flex justify-end">
              <Stack direction="horizontal" gap={3} className="items-center">
                <ReusableButton
                  fullWidth={false}
                  variant="outlined"
                  color="#292D32"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 25px"
                  height="44px"
                  bgColor="transparent"
                  fontFamily="Akkurat"
                  onClick={() => navigate(superAdminCoupons(locale))}
                >
                  <FormattedMessage id="Cancel" />
                </ReusableButton>

                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="400"
                  padding="12px 35px"
                  height="44px"
                  bgColor="#292D32"
                  fontFamily="Akkurat"
                  endIcon={
                    couponLoader && (
                      <CircularProgress
                        style={{
                          color: 'white',
                          width: '20px',
                          height: '20px',
                        }}
                      />
                    )
                  }
                  onClick={() => handleCreateCoupon()}
                >
                  <FormattedMessage id="Save" />
                </ReusableButton>
              </Stack>
            </div>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default CreateCoupon;
